<template>
  <div class="histogram">
    <div ref="echarts" id="echarts" style="width:100%;height:100%;"></div>
  </div>
</template>
<script>
export default {
  props: {
    histogramData: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      echartsData: this.histogramData,
      myTitle: this.title
    }
  },
  watch: {
    histogramData (newV) {
      this.init_histogram(this.$refs.echarts, newV, this.myTitle)
    }
  },
  mounted () {
    this.init_histogram(this.$refs.echarts, this.echartsData, this.myTitle)
  },
  methods: {
    init_histogram (name, data, title) {
      let myChart = this.$echarts.init(name)
      let option = {
        title: {
          text: title,
          x: 'left',
          textStyle: {
            fontWeight: '400'
          }
        },
        tooltip: {
          trigger: 'axis',
          show: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '0',
          containLabel: true
        },
        xAxis: [
          {
            splitLine: {
              show: false
            },
            type: 'value',
            show: false
          }

        ],
        yAxis: [
          {
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              fontSize: 15,
              formatter: function (val) {
                if (val.length > 4) {
                  return `${val.slice(0, 4)}...`
                } else {
                  return val
                }
              }
            },
            axisLine: {
              // y轴
              show: false
            },
            type: 'category',
            axisTick: {
              show: false
            },
            inverse: true,
            data: data.map(item => item.name)
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: 24, // 柱子宽度
            label: {
              show: false,
              position: 'inside', // 位置
              color: '#DFC373',
              fontSize: 12,
              distance: 40, // 距离
              formatter: '{c}' // 这里是数据展示的时候显示的数据
            }, // 柱子上方的数值
            data: data
          }
        ]
      }
      myChart.setOption(option)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.histogram {
  width: 100%;
  height: 100%;
  color: #c55e59;
}
</style>



// WEBPACK FOOTER //
// src/components/histogram.vue